let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5465r"), load("fkY2m"), load("fZyYv")]).then(() => parcelRequire('7PP2u'));